<template>
  <b-card style="width:1000px;height:100%;overflow-y:auto;">
    <p>Select address</p>
    <vis-full-name-address-editor :editor="editor" :component="component"></vis-full-name-address-editor>
    <button @click="openChat" :disabled="!chatInit">Open Chat</button>
    <p>Unread messages: {{unreadMessageCount}}</p>
    <p v-if="chatLoadError">Error load chat</p>

    <!--<vis-chat
      :chatApi="chatApi"
      :iceServers="iceServers"
      :assetsPath="assetsPath"
      ref="chat"
      @loaded="onChatLoaded"
    />-->
    <br />
    <br />

    <vis-filestorage-chooser
      v-model="value1"
      @change="onChanged1"
      :server-api="serverApi"
      :file-handler-api="fileHandlerApiUrl"
      multiselect
      upload-drive-primary
      upload-drive-first
      uploadBtnDisabled
      selectBtnDisabled
    />
    <!-- <div>Value: {{ value1 }}</div> -->
    <button @click="select1">Select File</button>

    <br />
    <br />

    <vis-filestorage-chooser
      v-model="value2"
      @change="onChanged2"
      :server-api="serverApi"
      :file-handler-api="fileHandlerApiUrl"
      multiselect
      upload-drive-primary
      upload-drive-first
      :show-history="false"
      :show-preview="true"
      crop-editor
      view-type="list"
    />
    <!-- <div>Value: {{ value2 }}</div> -->
    <button @click="select2">Select File</button>

    <br />
    <br />

    <vis-filestorage-chooser
      v-model="value3"
      @change="onChanged3"
      :server-api="serverApi"
      :file-handler-api="fileHandlerApiUrl"
      upload-drive-primary
      upload-drive-first
      :preview-height-auto="false"
      :show-history="true"
      :show-preview="true"
      multiselect
    />
    <div>Value: {{ value3 }}</div>

    <br />
    <br />

    <vis-filestorage-link
      :link="value1"
      :server-api="serverApi"
      :file-handler-api="fileHandlerApiUrl"
    />

    <br />
    <br />

    <vis-filestorage-link
      :link="link1"
      :server-api="serverApi"
      :file-handler-api="fileHandlerApiUrl"
    />

    <br />
    <br />

    <vis-filestorage-link
      :link="link2"
      :server-api="serverApi"
      :file-handler-api="fileHandlerApiUrl"
    />
    <br />
    <button @click="selectLink">Select Link</button>
  </b-card>
</template>

<script>
import VisFilestorageChooser from "@/views/vis-filestorage-chooser";
import VisFilestorageLink from "@/views/vis-filestorage-link";
import VisChat from "@/views/vis-chat";
import globalState from "../shared/global-state";

export default {
  name: "vis-test-widgets",
  components: {
    VisFilestorageChooser,
    VisFilestorageLink,
    VisChat
  },
  data() {
    return {
      serverApi: globalState.launchConfig.fileStorage.serverApiUrl,
      fileHandlerApiUrl: globalState.launchConfig.fileStorage.fileHandlerApiUrl,
      value1: null,
      value2: [],
      value3: [],
      link1:
        "egBSFj1sEqvDC3robcJc3xus-I12Jrmyi5b0DeIQTS73A9_bUWlotSGWux9rvFlUMlpNcga7inEgFOaYDEOd1ZCNMemEUikf6yVjGkvQapfoHZcxsxc1WQj2lUDerwj_R8ZFz2n6_32DxT_uBusfcuBT5Tgx2KXoVPtrkmpOLuFrFZqX1M56wABGhoOAPsk4xQH3eaO2SiBzKj3iqKrjT1jcN5XPfFVzsrWvtitBN_QwcSCd0TDykIlZEAXZ57EahSYQiHkMOin83jUF3-oSwlF4k2aSJoNAWcbkrj3mmvbllaWXe4E_n5V4Rtz5j0Ich16XnJSasp8BgqHdsAw_cAUL_J22LXczNF5RZG0zsv6vcsK7U3qkCF_TVYRHnA9sFF0JJ_Tk7ERElDFKqlhNv7W5uaSNC9CU3Al9Xz39nXsmPzDRbhFpYiIHB-Tgns0_TnhcqSdhoMkF1ssuMEuI_0H7HZ070Ld6KCLCpN4jJoOggTZGItw78h0COXQ6lipy-PJGk81lHKNCPJmNcPh2pJUjhvOgzLU6ThV7IvxbNv4GSkM3EH5tylg3vUH2T2pVi3J3LYDzkQHxDtRrgfIlXrXMSHQtiZ-M2MfNASCgSPkBgUsW59s4qwOWdAyE5oiWrHCgGKVNND9J75OakDLJDgHqCDwo41VKP3TQ4acAlls",
      link2: null,

      chatApi: globalState.launchConfig.chat.chatApiUrl,
      iceServers: globalState.launchConfig.chat.iceServers,
      assetsPath: globalState.launchConfig.chat.assetsPath,
      chatInit: false,
      unreadMessageCount: 0,
      chatLoadError: false
    };
  },
  methods: {
    onChanged1() {
      console.log("VisFilestorageChooser::onChanged1");
    },
    onChanged2() {
      console.log("VisFilestorageChooser::onChanged2");
    },
    onChanged3() {
      console.log("VisFilestorageChooser::onChanged3");
    },
    select1() {
      this.value1 =
        "kFfPw4tTCAuChfgyqgURjOXG-XRP66y8hcRVjyGzynQmc8am_e5FuJo2oVpH-YGDrz0E2hC8ApQ6Q0EPOCpCTWdeNirqEA1WkEfHjj3JaAxvMfrp39CRFpnabDFWfWMYmb3WswFW1qYarcOlcgN77TW3RuuYAEUs8Xgdw7qSGrGuy01sgJcaXyPhyV44XbAkPPTlZid22r1pwUjlRKM7x6zi4xs7ABrpgbTV-H8YK2oZ4mK-4C0hiYfSqKFaZDvro5bEN9CWK9df3UrQ8KFIqvex37iV67j69pHsN1a9GdxPTWHwR9S0Ty3WBCFMk3x4eJ2z_CftpJ0Ui-0GU9nKnxXHsLewDfQCnpjYW-AuCK0xa7NqQuZHYQzzca-9Y0eCZxd87DHfsrZ1DT_FLbOG51Brnx6_qai1-qciddHcImpi0n6Mk-qqZTOpWWeIIaIB4OppjrxsxB8HgAMN-NVTtaBVYcrMnwKE3P1JU9AN8sVoYX83glmXQVNiRISnMuWvWW8WyYNwxGwxfASZcFQYiHBC20q37mbIUQ72rpXBXvj69FrmgX_qInpFAe4xQmeJVfT1GGV07lAEKiFBvCFswt7P8HL8hW1bFD6JO2NZwjB_whpD6GpSQvVQgPB4EclSfjPv4x3Rd5x4hqliv86IKTRG-Kpm2Oj1OSwIr5QGOqo";
    },
    select2() {
      this.value2 = [
        "kFfPw4tTCAuChfgyqgURjOXG-XRP66y8hcRVjyGzynQmc8am_e5FuJo2oVpH-YGDrz0E2hC8ApQ6Q0EPOCpCTWdeNirqEA1WkEfHjj3JaAxvMfrp39CRFpnabDFWfWMYmb3WswFW1qYarcOlcgN77TW3RuuYAEUs8Xgdw7qSGrGuy01sgJcaXyPhyV44XbAkPPTlZid22r1pwUjlRKM7x6zi4xs7ABrpgbTV-H8YK2oZ4mK-4C0hiYfSqKFaZDvro5bEN9CWK9df3UrQ8KFIqvex37iV67j69pHsN1a9GdxPTWHwR9S0Ty3WBCFMk3x4eJ2z_CftpJ0Ui-0GU9nKnxXHsLewDfQCnpjYW-AuCK0xa7NqQuZHYQzzca-9Y0eCZxd87DHfsrZ1DT_FLbOG51Brnx6_qai1-qciddHcImpi0n6Mk-qqZTOpWWeIIaIB4OppjrxsxB8HgAMN-NVTtaBVYcrMnwKE3P1JU9AN8sVoYX83glmXQVNiRISnMuWvWW8WyYNwxGwxfASZcFQYiHBC20q37mbIUQ72rpXBXvj69FrmgX_qInpFAe4xQmeJVfT1GGV07lAEKiFBvCFswt7P8HL8hW1bFD6JO2NZwjB_whpD6GpSQvVQgPB4EclSfjPv4x3Rd5x4hqliv86IKTRG-Kpm2Oj1OSwIr5QGOqo",
        "egBSFj1sEqvDC3robcJc3xus-I12Jrmyi5b0DeIQTS73A9_bUWlotSGWux9rvFlUMlpNcga7inEgFOaYDEOd1ZCNMemEUikf6yVjGkvQapfoHZcxsxc1WQj2lUDerwj_R8ZFz2n6_32DxT_uBusfcuBT5Tgx2KXoVPtrkmpOLuFrFZqX1M56wABGhoOAPsk4xQH3eaO2SiBzKj3iqKrjT1jcN5XPfFVzsrWvtitBN_QwcSCd0TDykIlZEAXZ57EahSYQiHkMOin83jUF3-oSwlF4k2aSJoNAWcbkrj3mmvbllaWXe4E_n5V4Rtz5j0Ich16XnJSasp8BgqHdsAw_cAUL_J22LXczNF5RZG0zsv6vcsK7U3qkCF_TVYRHnA9sFF0JJ_Tk7ERElDFKqlhNv7W5uaSNC9CU3Al9Xz39nXsmPzDRbhFpYiIHB-Tgns0_TnhcqSdhoMkF1ssuMEuI_0H7HZ070Ld6KCLCpN4jJoOggTZGItw78h0COXQ6lipy-PJGk81lHKNCPJmNcPh2pJUjhvOgzLU6ThV7IvxbNv4GSkM3EH5tylg3vUH2T2pVi3J3LYDzkQHxDtRrgfIlXrXMSHQtiZ-M2MfNASCgSPkBgUsW59s4qwOWdAyE5oiWrHCgGKVNND9J75OakDLJDgHqCDwo41VKP3TQ4acAlls"
      ];
    },
    selectLink() {
      this.link2 =
        "kFfPw4tTCAuChfgyqgURjOXG-XRP66y8hcRVjyGzynQmc8am_e5FuJo2oVpH-YGDrz0E2hC8ApQ6Q0EPOCpCTWdeNirqEA1WkEfHjj3JaAxvMfrp39CRFpnabDFWfWMYmb3WswFW1qYarcOlcgN77TW3RuuYAEUs8Xgdw7qSGrGuy01sgJcaXyPhyV44XbAkPPTlZid22r1pwUjlRKM7x6zi4xs7ABrpgbTV-H8YK2oZ4mK-4C0hiYfSqKFaZDvro5bEN9CWK9df3UrQ8KFIqvex37iV67j69pHsN1a9GdxPTWHwR9S0Ty3WBCFMk3x4eJ2z_CftpJ0Ui-0GU9nKnxXHsLewDfQCnpjYW-AuCK0xa7NqQuZHYQzzca-9Y0eCZxd87DHfsrZ1DT_FLbOG51Brnx6_qai1-qciddHcImpi0n6Mk-qqZTOpWWeIIaIB4OppjrxsxB8HgAMN-NVTtaBVYcrMnwKE3P1JU9AN8sVoYX83glmXQVNiRISnMuWvWW8WyYNwxGwxfASZcFQYiHBC20q37mbIUQ72rpXBXvj69FrmgX_qInpFAe4xQmeJVfT1GGV07lAEKiFBvCFswt7P8HL8hW1bFD6JO2NZwjB_whpD6GpSQvVQgPB4EclSfjPv4x3Rd5x4hqliv86IKTRG-Kpm2Oj1OSwIr5QGOqo";
    },
    openChat() {
      this.$refs.chat.toggle();
    },
    onChatLoaded(error) {
      if (error) {
        this.chatLoadError = true;
      } else {
        this.chatInit = true;
      }
    }
  },
  async created() {
    this.editor = {
      Required: true,
      Readonly: false,
      IsSystem: false,
      valid: null,
      dirty: false
    };
    this.component = {
      Name: "Address",
      Params: {}
    };
  }
};
</script>
